export function isWZReturn(value: unknown): boolean {
    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'number') {
        return value === 1;
    }

    return typeof value === 'string' && ['true', '1', 'yes'].includes(value.trim().toLowerCase());
}
